import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';

import { AuthService } from '../../features/auth/services/auth.service';
import { PermissionService } from '../services/permission.service';

export const adminPermissionsGuard: CanActivateFn = (): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const evaluateAccess = (): boolean | UrlTree => {
    try {
      // The role-permissions matrix is reserved for MASTER_ADMIN only.
      if (permissionService.isCurrentUserMasterAdmin()) {
        return true;
      }

      return router.createUrlTree(['/dashboard']);
    } catch {
      return router.createUrlTree(['/dashboard']);
    }
  };

  if (!authService.isInitialized()) {
    return authService.waitForInitialization().pipe(map(() => evaluateAccess()));
  }

  return evaluateAccess();
};
